import React from 'react';
import { message, Modal } from 'antd';


export default class ReactComponent extends React.Component {

	constructor(props) {
		super(props);
 		if (ReactComponent === this.constructor) {
			throw new TypeError("Error! ReactComponent should be considered as an abstract class");
		}
	}

	handleError = message => console.error(message)

	toggleCurrentModal = status => {
		let currentStatus = {
			currentModalStatus: null === status ? !this.state.currentModalStatus : status
		}
		this.setState(currentStatus);
	}

	reloadAction = () => {
		let gets = {};
		Object.keys(this.state.filters).forEach(key => {
			if (this.state.filters[key]) {
				gets[key] = this.state.filters[key];
			}
		});
		let dataReloaded = false;
		if ("function" === typeof this.actions.selectAction) {
			this.actions.selectAction(gets, res => {
				dataReloaded = true;
				if (undefined !== res.data.Success && res.data.Success) {
					this.setState({
						dataStatus: "loaded",
						data: this.dataMode === 1 ? res.data.Object : res.data
					})
				}else{
					this.setState({dataStatus: "error",errors:res.data.Errors})
				}
			}, err => {
				dataReloaded = true;
				this.setState({
					dataStatus: "error"
				})
			})
			setTimeout(() => {
				if (!dataReloaded) {
					this.setState({
						dataStatus: "loading"
					});
				}
			}, 100);
		}else{
			this.handleError("undefined select action");
		}
	}

	componentWillMount() {
		if (!this.deleteRowSelection) {
			this.rowSelection = {
				onChange: (selectedRowKeys, selectedRows) => {
					let ids = selectedRows.map(row => row.id);
					this.setState({selectedIDs: ids});
				}
			}
		}
		if ("loaded" !== this.state.dataStatus || this.initReload) {
			if ('function' === typeof this.reloadAction) {
				this.reloadAction();
			}else{
				this.handleError('undefined reload action');
			}
		}
		if ("function" === typeof this.customComponentWillMount) {
			this.customComponentWillMount();
		}
	}

	componentWillReceiveProps(nextProps) {
		if ("function" === typeof this.customComponentWillReceiveProps) {
			this.customComponentWillReceiveProps(nextProps);
		}
	}

	publicCreate = posts => {
		if ("function" === typeof this.actions.createAction) {
			this.actions.createAction(posts, res => {
				if (res.data.Success) {
					this.toggleCurrentModal(false);
					message.success("添加数据成功", 4);
					if ("function" === typeof this.reloadAction) {
						this.reloadAction();
					}else{
						this.handleError('undefined reload action');
					}
				}else{
					message.error("添加数据失败 " + res.data.Errors[0], 4);
				}
			});
		}else{
			this.handleError("undefined create action");
		}
	}

	publicAppend = (posts, callback) => {
		if ("function" === typeof this.actions.appendAction) {
			this.actions.appendAction(posts, res => {
				if (res.data.Success) {
					this.toggleCurrentModal(false);
					message.success("添加数据成功", 4);
					if ("function" === typeof callback) {
						callback(res);
					}
				}else{
					message.error("添加数据失败 " + res.data.Errors[0], 4);
				}
			});
		}else{
			this.handleError('undefined append action');			
		}
	}

	publicUpdate = (puts, callback) => {
		if ("function" === typeof this.actions.updateAction) {
			this.actions.updateAction(puts, this.state.currentIndex, res => {
				if (res.data.Success) {
					this.toggleCurrentModal(false);
					message.success("修改数据成功", 4);
					if ("function" === typeof callback) {
						callback(res);
					}
				}else{
					message.error("修改数据失败 " + res.data.Errors[0], 4);
				}
			});
		}else{
			this.handleError('undefined update action');
		}
	}

	publicDelete = callback => {
		if (!this.state.selectedIDs || 0 === this.state.selectedIDs.length) {
			message.error('请选择要删除的内容', 4);
			return false;
		}
		Modal.confirm({
			title: '确定删除选中的内容么?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				if ("function" === typeof this.actions.deleteAction) {
					this.actions.deleteAction({ids: this.state.selectedIDs}, res => {
						if (res.data.Success) {
							this.setState({selectedIDs: []});
							message.success('删除操作成功', 4);
							if ("function" === typeof callback) {
								callback(res)
							}else if ("function" === typeof this.reloadAction) {
								this.reloadAction();
							}else{
								this.handleError("undefined reload action");
							}
						}else{
							message.error('删除操作失败' + res.data.Errors[0], 4);
						}
					});
				}else{
					this.handleError('undefined delete action');
				}
			},
			onCancel: () => {}
		});
	}

	publicExport = gets => {
		let ref = Modal.info({
			content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"
		});
		if ("function" === typeof this.actions.exportAction) {
			this.actions.exportAction(gets, res => {
				ref.destroy();
				if (res.data.Success) {
					window.open(res.data.Message);
				}else{
					message.error('导出数据失败, ' + res.data.Errors[0], 4);
				}
			}, err => message.error('导出数据失败', 4))
		}else{
			this.handleError("undefined export action");
		}
	}
}


// WEBPACK FOOTER //
// ./src/routes/ReactComponent.js